import * as loadImage from "blueimp-load-image";

export default class FileWrapper {

  constructor(blob) {
    this.file = blob;
    this.fileName = blob.name;
    this.fileType = blob.type;
    this.dataURL = null;
    this.thumbnailUrl = null;
    this.inProgress = true;

    this.insertFilenameToDataUrl = this.insertFilenameToDataUrl.bind(this);
    this.setFileUrl = this.setFileUrl.bind(this);
    this.setFileThumbnailUrl = this.setFileThumbnailUrl.bind(this);
    this.getParsed = this.getParsed.bind(this);
    this.parseBlob = this.parseBlob.bind(this);
    this.setFileMetadata = this.setFileMetadata.bind(this);

    this.promise = this.parseBlob()
  }

  static fromBlob(blob) {
    return new FileWrapper(blob).getParsed()
  }

  getParsed() {
    return this.promise
  }

  /**
   * Reads {Blob} or {File} and gets its uri and then tries to retrieve any
   * metadata attached (exif, thumbnail)
   * @return {Promise<FileWrapper>}
   */
  parseBlob() {
    this.inProgress = false;
    return this.setFileUrl()
      .then(this.setFileMetadata)
      .then(this.setFileThumbnailUrl)
      .finally(() => {
        this.inProgress = false
      })
  }

  insertFilenameToDataUrl(url) {
    return url.replace(";base64", `;name=${this.fileName};base64`);
  }

  setFileUrl() {
    const wrapper = this;
    return new Promise((resolve, reject) => {
      loadImage(wrapper.file, resolve, {
        canvas: true
      })
    }).then((canvas) => {
      wrapper.dataURL = wrapper.insertFilenameToDataUrl(canvas.toDataURL());
      return wrapper
    })
  }

  setFileThumbnailUrl() {
    const wrapper = this;
    return new Promise((resolve, reject) => {
      loadImage(wrapper.file, resolve, {
        canvas: true,
        maxWidth: 220
      })
    }).then((canvas) => {
      wrapper.thumbnailUrl = wrapper.insertFilenameToDataUrl(canvas.toDataURL());
      return wrapper
    })
  }

  setFileMetadata() {
    const wrapper = this;
    return new Promise((resolve, reject) => {
      // Parse image metadata including exif
      try {
        loadImage.parseMetaData(
          wrapper.file,
          resolve,
          {
            maxMetaDataSize: 262144,
            disableImageHead: false
          }
        );
      } catch (e) {
        reject(e)
      }
    }).then(function (fileMetadata) {
      if (fileMetadata && fileMetadata.exif) {
        wrapper.file.meta = fileMetadata.exif.getAll()
      }
      return wrapper
    });
  }

  static rotate(wrapper) {
    wrapper.inProgress = true;
    return new Promise((resolve, reject) => {
      loadImage(wrapper.file, resolve, {
        canvas: true,
        orientation: 6
      })
    }).then((canvas) => {
      return new Promise((resolve, reject) => {
        canvas.toBlob((rotatedBlob) => {
          return resolve(FileWrapper.fromBlob(rotatedBlob))
        })
      })
    }).finally(() => {
      wrapper.inProgress = false
    })
  }
}
